import { API_ENDPOINTS } from "./endpoints";
import { requestJson, toArray } from "./httpClient";

export const fetchOrders = async ({ mine = false } = {}) => {
    const url = mine ? `${API_ENDPOINTS.orders.list}?mine=true` : API_ENDPOINTS.orders.list;
    const data = await requestJson(url);
    return toArray(data);
};

export const sendOrderEmail = (orderId, { to, subject, body, sendAsAuthenticatedUser = false }) =>
    requestJson(API_ENDPOINTS.orders.email(orderId), {
        method: "POST",
        body: {
            to,
            subject,
            body,
            ...(sendAsAuthenticatedUser ? { send_as_authenticated_user: true } : {})
        }
    });
